import calcWorth from "./calc-worth";

export default {
  checkTicketCount: {
    true: (value, cost, ticketsCount) => {
      if (
        $(".js-field-dropdown-tickets__title_cost-checkout").length &&
        ticketsCount === 1
      )
        return [1, cost];

      return undefined;
    },

    false: (value, cost) => {
      return [value, cost];
    }
  },

  addTicketInMap(field) {
    const $fieldName = $(field).attr("id")
      ? $(field).attr("id")
      : $(field).attr("name");
    const $ageBandName = $(field).attr("name");
    const $cost = $(field).data("cost");
    const $value = Number.parseFloat($(field).val());
    const $labelWrap = $(field)
      .closest(".js-field-dropdown__hidden")
      .siblings(".js-field-dropdown__label");
    const $ticketsField = $($labelWrap).find(".js-field-dropdown__field_btn");
    const form = $(field).closest(".js-product-order");
    const $totalCostWrap = $(form).find(".js-field-dropdown__subtotal-wrap");
    const $nonRefundableWrap = $(form).find('.js-field-dropdown__non-refundable-wrap');
    const $totalCostBlock = $(form).find(".js-field-dropdown__subtotal");
    const ticketsList = $($ticketsField).data("tickets")
      ? $($ticketsField).data("tickets")
      : { categories: {} };

    const fieldInfo = this.checkTicketCount[!$value](
      $value,
      $cost,
      ticketsList["ticketsCount"]
    );

    let comma = "";

    if (!fieldInfo) {
      delete ticketsList["categories"][$fieldName];
    } else {
      fieldInfo.name = $ageBandName ? $ageBandName : "";
      ticketsList["categories"][$fieldName] = fieldInfo;
      $(field).val(fieldInfo[0]);
    }

    ticketsList["ticketsCount"] = 0;
    ticketsList["totalCost"] = 0;
    ticketsList["toString"] = "";

    for (let ticket in ticketsList.categories) {
      let name = ticketsList["categories"][ticket]["name"]
        ? ticketsList["categories"][ticket]["name"]
        : ticket;

      ticketsList.toString +=
        comma + name + " x " + ticketsList["categories"][ticket][0];

      comma = ", ";

      ticketsList.ticketsCount++;

      ticketsList.totalCost +=
        ticketsList["categories"][ticket][0] *
        ticketsList["categories"][ticket][1];
    }

    $($ticketsField).data("tickets", ticketsList);

    $($ticketsField).val(ticketsList.toString);
    $($ticketsField).attr("title", ticketsList.toString);

    $($totalCostWrap).addClass("is-show");
    $($totalCostBlock).text("$".concat(ticketsList.totalCost.toFixed(2)));
    $($labelWrap).addClass("has-value");

    $($nonRefundableWrap).addClass("is-show");

    $(".js-book-now").attr("disabled", true);

    if (ticketsList.ticketsCount) return;

    $($ticketsField).val("Select Tickets");
    $($ticketsField).attr("title", "");
    $($labelWrap).removeClass("has-value");

    $($totalCostWrap).removeClass("is-show");
    $($totalCostBlock).text("$0");

    $($nonRefundableWrap).removeClass("is-show");

    return ticketsList;
  },

  changeInputNumber() {
    const _this = this;

    $(".js-product-order").each(function() {
      const $allFields = $(this).find(".js-field-dropdown-tickets__category");

      let total = 0;
      $allFields.each(function() {
        total +=
          $(this)
            .find(".js-field-dropdown-tickets__field")
            .val() * 1;
      });
      if (total <= 1) {
        $allFields
          .find('.js-field-dropdown-tickets__btn[data-incr="false"]')
          .addClass("is-disabled");
      }
    });

    $(".js-product-order").on(
      "click",
      ".js-field-dropdown-tickets__btn",
      function() {
        if ($(this).hasClass("is-disabled")) return;

        const $field = $(this).siblings(".js-field-dropdown-tickets__field");
        const incr = $(this).data("incr");
        const $allFields = $(this)
          .closest(".js-field-dropdown-tickets__category")
          .parent()
          .find(".js-field-dropdown-tickets__category");

        let total = 0;
        $allFields.each(function() {
          total +=
            $(this)
              .find(".js-field-dropdown-tickets__field")
              .val() * 1;
        });

        let $value = $($field).val();
        let totalCost = 0;

        if (incr) {
          total++;
          $($field).val(++$value);

          $(this)
            .siblings(".js-field-dropdown-tickets__btn")
            .removeClass("is-disabled");

          if ($value >= $($field).attr("max")) {
            $(this).addClass("is-disabled");
            $($field).val($($field).attr("max"));
          }
        } else {
          total--;
          $($field).val(--$value);

          $(this)
            .siblings(".js-field-dropdown-tickets__btn")
            .removeClass("is-disabled");

          if ($value <= 0) {
            $(".js-information__error-box.information__error-box")
              .addClass("hidden")
              .closest(".js-field-dropdown__label")
              .removeClass("has-error");
            $(this).addClass("is-disabled");
            $($field).val(0);
          }
        }

        if (
          $(document)
            .find(".js-is-checkout")
            .val()
        ) {
          if (total <= 1) {
            $allFields
              .find('.js-field-dropdown-tickets__btn[data-incr="false"]')
              .addClass("is-disabled");
          } else {
            $allFields.each(function() {
              const val = $(this)
                .find(".js-field-dropdown-tickets__field")
                .val();
              if (val > 0) {
                $(this)
                  .find('.js-field-dropdown-tickets__btn[data-incr="false"]')
                  .removeClass("is-disabled");
              }
            });
          }
        }

        _this.addTicketInMap($field);
        calcWorth.calcSubtotal();
        calcWorth.calcDiscount();
        calcWorth.calcTotal();
      }
    );

    $(".js-product-order").on(
      "change",
      ".js-field-dropdown-tickets__field",
      function() {
        let value = $(this).val();

        value = Number.parseFloat($(this).val());

        if (value >= Number.parseFloat($(this).attr("max"))) {
          $(this).val($(this).attr("max"));

          $(this)
            .siblings('.js-field-dropdown-tickets__btn[data-incr="true"]')
            .addClass("is-disabled");

          $(this)
            .siblings('.js-field-dropdown-tickets__btn[data-incr="false"]')
            .removeClass("is-disabled");
        } else if (value <= 0 || Number.isNaN(value)) {
          $(this).val(0);

          $(this)
            .siblings('.js-field-dropdown-tickets__btn[data-incr="false"]')
            .addClass("is-disabled");

          $(this)
            .siblings('.js-field-dropdown-tickets__btn[data-incr="true"]')
            .removeClass("is-disabled");
        } else {
          $(this)
            .siblings('.js-field-dropdown-tickets__btn[data-incr="false"]')
            .removeClass("is-disabled");

          $(this)
            .siblings('.js-field-dropdown-tickets__btn[data-incr="true"]')
            .removeClass("is-disabled");

          _this.addTicketInMap(this);
        }

        calcWorth.calcSubtotal();
        calcWorth.calcDiscount();
        calcWorth.calcTotal();
      }
    );

    $(".js-product-order").on(
      "input",
      ".js-field-dropdown-tickets__field",
      function() {
        let value = $(this).val();

        value = Number.parseFloat($(this).val());

        if (value >= Number.parseFloat($(this).attr("max"))) {
          $(this).val($(this).attr("max"));

          $(this)
            .siblings('.js-field-dropdown-tickets__btn[data-incr="true"]')
            .addClass("is-disabled");

          $(this)
            .siblings('.js-field-dropdown-tickets__btn[data-incr="false"]')
            .removeClass("is-disabled");
        } else if (value <= 0) {
          if ($(this).val().length > 0) {
            $(this).val(0);
          }

          $(this)
            .siblings('.js-field-dropdown-tickets__btn[data-incr="false"]')
            .addClass("is-disabled");

          $(this)
            .siblings('.js-field-dropdown-tickets__btn[data-incr="true"]')
            .removeClass("is-disabled");
        } else {
          $(this)
            .siblings('.js-field-dropdown-tickets__btn[data-incr="false"]')
            .removeClass("is-disabled");

          $(this)
            .siblings('.js-field-dropdown-tickets__btn[data-incr="true"]')
            .removeClass("is-disabled");
        }
      }
    );
  }
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/product/tickets-form/tickets-field.js